import { PriceTableContent, RowContent, priceTableData } from "constants/pricesNew";

import { useContext } from "react";

import { Typography, Divider } from "antd";
import { AppContext } from "App";
import PricingCheckmark from "assets/images/check.svg";
import PricingCross from "assets/images/pricing-cross.svg";
import StartButtonPricing from "components/basic/StartButtonPricing";

/* eslint-disable no-unused-vars */
export enum ReviewStatus {
    accountantReview = "Review by an accountant",
}
const PriceTableRow = ({ text }: RowContent) => {
    const isReview = text === ReviewStatus.accountantReview;
    const image = isReview ? PricingCross : PricingCheckmark;
    return <div className="vertical-center gap10">
        <img src={image} alt="checkmark or cross" width={"20px"}/>
        <Typography>{text}</Typography>
    </div>;
};

const PriceTable = ({ category, title, price, priceSubScript, rows, isAvailable, popular }: PriceTableContent) => {
    const { isMobile } = useContext(AppContext);

    return (
        <div style={{
            borderRadius: "32px",
            display: "flex",
            flexDirection: "column",
            width: isMobile ? undefined : "25%",
            backgroundColor: "white",
            height: "fit-content",
            minWidth: "320px",
        }}>
            {!isAvailable && <Typography className="price-tables__availability">Coming soon</Typography>}
            <div className={popular ? "price-tables__card-purple" : "price-tables__card" }>
                <div style={{ display: "flex", flexDirection: "column", maxWidth: "320px" }}>
                    <div className="horizontal-right">
                        {popular && <div className="price-tables__banner">{popular}</div>}
                    </div>
                    <Typography className="price-tables__category">{category}</Typography>
                    <Typography className="price-tables__title">{title}</Typography>
                    <Typography.Text className="price-tables__price">
                        {price}
                    </Typography.Text>
                    <p className="price-tables__price-subscript">{priceSubScript}</p>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "16px", maxWidth: "320px" }}>
                    {rows.map((row, index) => (
                        <div key={index}><PriceTableRow text={row.text}/><Divider className="price-tables__rows"/></div>
                    ))}
                </div>
                <StartButtonPricing label="Get Started" className={popular ? "shared__primary-button w100" : "shared__secondary-button w100"}/>
            </div>
        </div>
    );
};

const PriceTables = () => {
    const { isMobile, maxWidth } = useContext(AppContext);

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            gap: "32px",
            padding: isMobile ? "0" : "40px",
            flexDirection: isMobile ? "column" : "row",
            maxWidth: maxWidth,
            marginBottom: isMobile ? "20px" : "",

        }}>
            {priceTableData.map((table, index) => <PriceTable key={index} {...table} />)}
        </div>
    );
};

export default PriceTables;
